import React from 'react';

interface IRamsOptions {
    text: string;
    textLine2?: undefined | string;
    textLine3?: undefined | string;
    value: string;
    priorityValue?: undefined | string;
}

export function RamsItem(props: { topLetter: string; ramsScore?: undefined | string; ramsOptions: IRamsOptions[]; header: string }) {
    const ramsOption = props.ramsOptions.find((ramsItem) => ramsItem.value === props.ramsScore);

    return (
        <span className="panel-ramssheepItem">
            <span>{props.topLetter}</span>
            {(props.ramsScore && (
                <div className={`value tooltipZXY rams${ramsOption?.priorityValue}`}>
                    {props.ramsScore}
                    <span className="tooltiptext">
                        <strong>{props.header}</strong>
                        <br />
                        {ramsOption?.text}
                        {ramsOption?.textLine2 && <div>{ramsOption?.textLine2}</div>}
                        {ramsOption?.textLine3 && <div>{ramsOption?.textLine3}</div>}
                    </span>
                </div>
            )) || <div className="value rams">{props.ramsScore}</div>}
        </span>
    );
}
